export const REACT_APP_API_BASE =
  process.env.REACT_APP_API_BASE ||
  `https://ancora-imparo-notes-api.herokuapp.com`;
